import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import RoutingService from '../../../services/RoutingService';
import ListPanel from '../../../components/list-panel/ListPanel';
import RESTService from '../../../services/RESTService';
import CommonService from '../../../services/CommonService';
import TimeAgo from '../../../../node_modules/react-timeago/lib/index';
import Spinner from '../../../components/spinner/Spinner';
import DialogModal from '../../../components/dialog-modal/DialogModal';
import AppConfigService from '../../../services/AppConfigService';
import CloneModal from '../../../components/clone-modal/CloneModal';

const RS = new RoutingService();
const connect = new RESTService();
const CS = new CommonService();
const ACS = new AppConfigService();

class EndpointList extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			endpoints: [],
			epMap: {},
			loading: true,
			searchText: '',
			toClone: {},
			showClone: false,
			showDeleteModal: false
		};
		this.autoBind(['onCreate', 'buildEndpointList', 'onSearchChange', 'onOpenEndpoint']);
	}

	componentDidMount() {
		connect
			.getEndpoints()
			.then(res => {
				this.observe(() => {
					this.data.endpoints = res.data;
					this.data.epMap = CS.mapByParam('_id', res.data);
					this.data.loading = false;
				});
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	onSearchChange(evt) {
		this.setData('searchText', evt.target.value);
	}

	onCreate() {
		this.props.onCreateEndpoint();
		RS.goToRoute('/endpoints/create');
	}

	onOpenEndpoint(evt) {
		if (evt.target.classList.contains('mdi') || evt.target.classList.contains('action')) {
			return;
		}
		let id = evt.target.dataset.id;
		let ep = this.data.epMap[id];
		if (ep) {
			this.props.onEditEndpoint(ep);
			RS.goToRoute('/endpoints/edit');
		}
	}

	onDelete = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let ep = this.data.epMap[id];
			if (ep) {
				this.observe(() => {
					this.data.showDeleteModal = true;
					this.data.toDelete = ep;
				});
			}
		}
	};

	onCopy = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let ep = this.data.epMap[id];
			if (ep) {
				this.observe(() => {
					this.data.toClone = ep;
					this.data.showClone = true;
				});
			}
		}
	};

	onClearCache = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let ep = this.data.epMap[id];
			if (ep) {
				connect
					.clearEndpointCache(ep.name)
					.then(() => {
						RS.showSuccess();
					})
					.catch(err => {
						RS.smartError(err);
					});
			}
		}
	};

	toggleDeleteModal = () => {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	};

	onConfirmDelete = () => {
		this.toggleDeleteModal();
		let ep = this.data.toDelete;
		if (ep) {
			connect
				.deleteEndpoint(ep.name)
				.then(() => {
					RS.showSuccess();
					ACS.removeEndpoint(ep.name);
					this.componentDidMount();
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	buildEndpointList() {
		if (this.data.loading) {
			return <Spinner text="Loading Endpoints..." />;
		}
		let eps = this.data.endpoints;
		if (eps.length <= 0) {
			return <div className="empty-list">Your application has no endpoints.</div>;
		}
		let items = [];
		for (let i = 0; i < eps.length; i++) {
			let ep = eps[i];
			if (this.data.searchText.length === '' || ep.name.indexOf(this.data.searchText) >= 0) {
				items.push(
					<div className="list-item hbox vcenter" key={'list-item-' + ep._id} data-id={ep._id} onClick={this.onOpenEndpoint}>
						<div className="name grow-1" data-id={ep._id}>
							{ep.name}
						</div>
						<div className="connection grow-1 hbox vcenter" data-id={ep._id}>
							{!ep.connection ? <i className="mdi mdi-json" /> : <i className="mdi mdi-lan-pending" />}
							{ep.connection ? ep.connection : 'Script'}
						</div>
						<div className="updated grow-1" data-id={ep._id}>
							<TimeAgo date={ep.updateDate || ep.creationDate} data-id={ep._id} />
						</div>
						<div className="actions grow-1 hbox vcenter" data-id={ep._id}>
							<div className="action vbox hcenter vcenter" data-rh="Clone Endpoint" data-rh-at="top" data-id={ep._id} onClick={this.onCopy}>
								<i className="mdi mdi-content-duplicate" data-id={ep._id} />
							</div>
							<div className="action vbox hcenter vcenter" data-rh="Clear Cache" data-rh-at="top" data-id={ep._id} onClick={this.onClearCache}>
								<i className="mdi mdi-broom" data-id={ep._id} />
							</div>
							<div className="action vbox hcenter vcenter" data-rh="Delete Endpoint" data-rh-at="top" data-id={ep._id} onClick={this.onDelete}>
								<i className="mdi mdi-delete" data-id={ep._id} />
							</div>
						</div>
					</div>
				);
			}
		}
		if (items.length <= 0) {
			return <div className="empty-list">No endpoints match your query.</div>;
		}
		return items;
	}

	toggleCloneModal = () => {
		this.setData('showClone', !this.data.showClone);
	};

	cloneEndpoint = name => {
		let newEp = JSON.parse(JSON.stringify(this.data.toClone));
		newEp.name = name;
		delete newEp._id;
		delete newEp.creationDate;
		this.observe(() => {
			this.data.showClone = false;
			this.data.loading = true;
		});
		connect
			.createEndpoint(newEp)
			.then(res => {
				this.observe(() => {
					ACS.populateEndpoint(res.data);
					this.data.loading = false;
					this.componentDidMount();
				});
			})
			.catch(err => {
				RS.smartError(err);
				this.observe(() => {
					this.data.showClone = false;
					this.data.loading = true;
				});
			});
	};

	render() {
		return (
			<div className="endpoint-list-view animated fadeIn">
				<div className="endpoints-list-header hbox vcenter hright">
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input className="search-input" value={this.data.searchText} onChange={this.onSearchChange} placeholder="Search Endpoints..." />
					</div>
				</div>
				<ListPanel
					name="Endpoints List"
					className="endpoint-list-cmp"
					labels={['name', 'connection', 'updated', 'actions']}
					onCreate={this.onCreate}
					listItems={this.buildEndpointList()}
				/>
				<CloneModal
					isOpen={this.data.showClone}
					onCancel={this.toggleCloneModal}
					cloneObject={this.cloneEndpoint}
					toClone={this.data.toClone}
					title="Clone Endpoint"
				/>
				<DialogModal
					isOpen={this.data.showDeleteModal}
					type="warning"
					showCancelButton={true}
					cancelBtnText="Cancel"
					confirmBtnText="Delete"
					text="Deleting an endpoint cannot be undone"
					title="Are you sure?"
					onConfirm={this.onConfirmDelete}
					onCancel={this.toggleDeleteModal}
				/>
			</div>
		);
	}
}

export default EndpointList;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/endpoint-list/EndpointList.js